<template>
    <div :class="classes" :role="role">
        <span class="sr-only"> {{ title }}</span>
    </div>
</template>

<script>
export default {
    props: {
        classes: String,
        role: String,
        title: String
    }
}
</script>
